/* eslint-disable no-constant-binary-expression */
import { FC } from 'react';
import { clsx } from 'clsx';
import { addTime } from 'shared/lib';

import { ICardLineGroupScheduleProps } from '../models/types';

import styles from './styles.module.scss';

export const CardLineGroupSchedule: FC<ICardLineGroupScheduleProps> = ({
  data,
}) => {
  return (
    <div className={styles['card-line-schedule']}>
      <div>
        <div className={styles['card-line-schedule__disctime']}>
          {data.disciplTime} <div>—</div> <div>{addTime(data.disciplTime)}</div>
        </div>
      </div>

      <div className={styles['card-line-schedule__info']}>
        <div className={styles['card-line-schedule__header']}>
          <div
            className={clsx(styles['card-line-schedule__disctype'], {
              [styles['card-line-schedule__disctype_red']]:
                data.disciplType === 'Лекция',
              [styles['card-line-schedule__disctype_blue']]:
                data.disciplType === 'Лабораторная работа',
              [styles['card-line-schedule__disctype_purple']]:
                data.disciplType === 'Практика',
            })}
          >
            <div>{data.disciplType}</div>
          </div>
          {data.subgroupNum && (
            <div className={styles['card-line-schedule__subgroup']}>
              {data.subgroupNum}
              <div className={styles['card-line-schedule__subgroup-text']}>
                подгруппа
              </div>
            </div>
          )}
        </div>

        <div className={styles['card-line-schedule__discname']}>
          {data.disciplName}
        </div>
        <div className={styles['card-line-schedule__building-auditory']}>
          {data.location}
        </div>
        {!!data.dateDayTags?.length && (
          <div className={styles['card-line-schedule__tags']}>
            {data.dateDayTags.map((tag) => {
              return (
                <div className={styles['card-line-schedule__tag']} key={tag}>
                  {tag}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
